module.exports = "/_next/static/images/2-f9ffaceab7895cca10f015e4e657a633.jpg";